import React, { createContext, useContext } from "react"
import { CardBack, CardDiv } from "./card.style"
import useFlip from "./flip"
import useDragMove from "./drag-move"
// import { isMobile } from "../../modules/utils"
import { Link } from "gatsby"
import { useContentFromPostId } from "../internal-teaser/internal-teaser"
import { LangContext } from "gatsby-source-dek-wp"
import { AuthContext } from "../../../plugins/gatsby-source-dek-wp/hooks/auth"

export const MovingContext = createContext(false)
export const DragBindContext = createContext<(...args: any[]) => any>(() => {})

interface TranslationObj {
  [key: string]: string
}

const labels: TranslationObj = {
  de: "ZUM ARTIKEL",
  en: "TO ARTICLE",
  ru: "К СТАТЬЕ",
  uk: "ДО СТАТТІ",
  be: "ДА АРТЫКУЛА",
}

const exampleText = `Россия начала военную операцию по демилитаризации Украины рано утром в четверг, 24 февраля. В телеобращении к россиянам президент Владимир Путин заявил, что обстоятельства "требуют от нас решительных и незамедлительных действий, народные республики Донбасса обратились с просьбой о помощи".`

const Card = ({
  children,
  onSelect = () => {},
  initialRot,
  postId,
  onClick,
}) => {
  const isAuthed = useContext(AuthContext)
  const [bind, style, set, moving] = useDragMove(onSelect, initialRot)
  const [flip, child, flipBtn] = useFlip(set, children) // flip

  const cardBind = bind() // isMobile() ? { onClick: onSelect } : bind()

  const content = useContentFromPostId(postId)
  const lang = useContext(LangContext)

  if (!content) {
    // console.error("Content not found", { postId })
    // return null
  }

  
  const hasBackText = child?.props?.template === "note" ?
      //making sure backText change only for note template:
      Array.isArray(child?.props?.backText) &&
      child.props.backText.length > 0 &&
      !(
        child.props.backText.length === 1 &&
        (!child.props.backText[0]?.props?.children ||
          child.props.backText[0].props.children === "")
      )
    : child?.props?.backText

  const onLinkClick = (e) => {
    if (moving && child?.props?.template != "note") {
      e.preventDefault()
      e.stopPropagation()
    } else if (typeof onClick === "function") {
      e.preventDefault()
      e.stopPropagation()
      onClick()
    } else if (!content) {
      e.preventDefault()
      e.stopPropagation()
    } else if(child?.props?.template === "note" && hasBackText) {
      e.preventDefault()
      e.stopPropagation()
      flip()
    }
  }


  return (
    <MovingContext.Provider value={moving}>
      <DragBindContext.Provider value={bind}>
        <CardDiv {...cardBind} style={style} onDoubleClick={flip}>
          <Link to={content ? `/${content?.slug}` : ""} onClick={onLinkClick}>
            {child}
          </Link>
          {hasBackText && flipBtn && (!content || (content?.published || isAuthed))}
          {hasBackText && (
            <CardBack>
              <div>
                {child?.props?.backText}
                {child?.props?.template === "note" && (
                  <Link to={content ? `/${content?.slug}` : ""} className="tile-share">{labels[lang.id]}</Link>
                )}
              </div>
            </CardBack>
          )}
        </CardDiv>
      </DragBindContext.Provider>
    </MovingContext.Provider>
  )
}
export default Card
